module.exports = __webpack_public_path__ + "img/Virtual_Chat.853049c8.jpg";